import React from 'react'
import Signup from '../components/Signup/Signup'



function LoginSignup() {
  return (
    <div>
      <Signup/>
    
    
      
    </div>
  )
}

export default LoginSignup
